import { jsx as s } from "@emotion/react/jsx-runtime";
import t, { tooltipClasses as i } from "@mui/material/Tooltip";
const r = i, l = ({ ...o }) => /* @__PURE__ */ s(t, { ...o });
l.displayName = "Tooltip";
export {
  l as T,
  r as t
};
